import ApiService from "../ApiService";

const LocationService = {
    getStatesByCountry(countryId, type, providerId) {
        countryId = countryId || 1;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/state/byCountryScheduleRanges/${countryId}/${type}/${providerId}`
        });
    },

    getCitiesByState(stateId, type, providerId) {
        stateId = stateId || 0;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/city/stateScheduleRanges/${stateId}/${type}/${providerId}`
        });
    },

    getBranchesByCityAndProvider(cityId, providerId, type) {
        cityId = cityId || 0;
        providerId = providerId || 0;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/branch/city/${cityId}/provider/${providerId}/type/${type}`
        });
    },

    getScheduleRangesByBranch(branchId) {
        branchId = branchId || 0;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/provider-schedule-range/branch/${branchId}`
        });
    },

    async forceShippingFeeAll() {
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/force-shipping-fee/all`
        });
    },

    getBranchesForUnifiedPharmacy(cityId) {
        cityId = cityId || 0;
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/branch/city/${cityId}/unified-pharmacy`
        });
    }
};

export default LocationService;
